
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Inputresponsive1469867751",
      {"classes":{"root":"Inputresponsive1469867751__root","size-tiny":"Typographyresponsive1941863919__size-tiny","size-small":"Typographyresponsive1941863919__size-small","size-medium":"Typographyresponsive1941863919__size-medium"},"vars":{"inner-border-color":"--Inputresponsive1469867751-inner-border-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  